import { render, staticRenderFns } from "./PdfEmbed.vue?vue&type=template&id=3e3b7083&scoped=true&"
import script from "./PdfEmbed.vue?vue&type=script&lang=js&"
export * from "./PdfEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PdfEmbed.vue?vue&type=style&index=0&id=3e3b7083&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b7083",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3b7083')) {
      api.createRecord('3e3b7083', component.options)
    } else {
      api.reload('3e3b7083', component.options)
    }
    module.hot.accept("./PdfEmbed.vue?vue&type=template&id=3e3b7083&scoped=true&", function () {
      api.rerender('3e3b7083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/schema/PdfEmbed.vue"
export default component.exports